<template>
  <div class="filmfest">
    <el-button type="primary" size="small" icon="el-icon-plus" @click="create">创建</el-button>

        <el-input v-model="key" size="small" style="margin-left: 20px; width: 200px;" placeholder="搜索"></el-input>

    <el-table :data="list" style="width: 100%" class="table">
      <el-table-column label="封面" width="120">
        <template slot-scope="scope">
          <img class="thumb" :src="scope.row.thumb">
        </template>
      </el-table-column>
      <el-table-column label="标题" width="150">
        <template slot-scope="scope"><span>{{scope.row.title}}</span></template>
      </el-table-column>
      <el-table-column label="时间" width="250">
        <template slot-scope="scope">
          <span>{{format(scope.row.start_at)}}</span> - <span>{{format(scope.row.end_at)}}</span>
        </template>
      </el-table-column>
      <el-table-column label="显示/隐藏" width="150">
        <template slot-scope="scope">
          <el-switch
            :active-value="0"
            :inactive-value="1"
            v-model="scope.row.is_hidden"
            @change="change($event, scope.row)">
          </el-switch>
        </template>
      </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="showAppPath(scope.row)">路径</el-button>
          <el-button type="text" size="small" @click="editItem(scope.row)">编辑</el-button>
          <el-button type="text" size="small" @click="deleteItem(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination class="pager" background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="page" :page-sizes="[5, 10, 15, 20]" :page-size="per_page" layout="total, sizes, prev, pager, next" :total="total">
    </el-pagination>
    <el-dialog :title="action===0?'创建':'编辑'" :visible.sync="dialogVisible" width="1200px">
      <el-form ref="form" :model="form" label-width="80px">
        <el-form-item label="封面">
          <img v-if="form.thumb" class="thumb cursor-pointer" :src="form.thumb" title="点击更换" @click="selectThumb('thumb')">
          <div v-else class="addimg" @click="selectThumb('thumb')">+</div>
        </el-form-item>
        <el-form-item label="标题">
          <el-input v-model="form.title" placeholder="名字" style="width: 400px"></el-input>
        </el-form-item>
        <el-form-item label="标题(英文)">
          <el-input v-model="form.title_en" placeholder="名字" style="width: 400px"></el-input>
        </el-form-item>
        <el-form-item label="时间">
          <el-col :span="11">
            <el-date-picker type="date" placeholder="开始时间" v-model="form.start_at" style="width: 100%;" value-format="yyyy-MM-dd"></el-date-picker>
          </el-col>
          <el-col class="line" :span="2" style="text-align:center">-</el-col>
          <el-col :span="11">
            <el-date-picker type="date" placeholder="结束时间" v-model="form.end_at" style="width: 100%;" value-format="yyyy-MM-dd"></el-date-picker>
          </el-col>
        </el-form-item>
        <el-form-item label="内容">

          <el-button-group style="margin-bottom: 20px;">
            <el-button size="small" value="cn"  :type="pageLang == 'cn' ? 'primary' : ''"  @click="changePageLang('cn')" :autofocus="true">中文版</el-button>
            <el-button size="small" value="en" :type="pageLang == 'en' ? 'primary' : ''" @click="changePageLang('en')">英文版</el-button>
          </el-button-group>

          <edit-box></edit-box>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button v-show="action===0" type="primary" @click="createFilmFest">确 定</el-button>
        <el-button v-show="action===1" type="primary" @click="saveChange">保存更改</el-button>
      </span>
    </el-dialog>
    <el-dialog :visible.sync="dialogVisible2" title="路径" center width="800px">
      <el-form label-width="80px">
        <el-form-item label="小程序">
          <el-input :value="miniAppPath">
          </el-input>
        </el-form-item>
      </el-form>
    </el-dialog>
    <upload-img ref="upload" tips-width="900" tips-height="900"></upload-img>
  </div>
</template>
<script>
import request from '@/utils/request'
import UploadImg from '@/components/UploadImg'
import editBox from '../pages/components/editBox'
export default {
  name: 'filmfest',
  components: {
    UploadImg,
    editBox
  },
  data () {
    return {
      pageLang: 'cn',
      action: 0,
      list: [],
      dialogVisible: false,
      dialogVisible2: false,
      miniAppPath: '',
      page: 1,
      per_page: 10,
      total: 0,
      form: {
        thumb: '',
        title: '',
        title_en: '',
        start_at: '',
        end_at: '',
        page: {
          style: {
            padding: 0
          },
          modules: []
        },
        page_en: {
          style: {
            padding: 0
          },
          modules: []
        }
      },
      rules: {},
      current: {},
      key: ''
    }
  },
  created () {
    this.getList()
    this.initEditBox()
  },
  watch: {
    key () {
      this.page = 1
      this.getList()
    }
  },
  methods: {
    changePageLang (lang)  {
      if (lang == 'cn') {
        this.$store.commit('SET_PAGE', this.form.page)
        this.$store.commit('SET_PAGE_CURRENTITEM', '')
      }
      else if (lang == 'en') {
        this.$store.commit('SET_PAGE', this.form.page_en)
        this.$store.commit('SET_PAGE_CURRENTITEM', '')
      }
      this.pageLang = lang
    },
    showAppPath (row) {
      this.miniAppPath = 'pages/filmfestDetail/index?uuid=' + row.uuid
      this.dialogVisible2 = true
    },
    initEditBox () {
      this.$store.commit('SET_PAGE', this.form.page)
      this.$store.commit('SET_PAGE_CURRENTITEM', '')
    },
    saveChange () {
      let sendData = JSON.parse(JSON.stringify(this.form))
      request({
        url: '/filmfest/' + this.current.uuid,
        method: 'patch',
        data: {
          type: 'update',
          attributes: sendData
        }
      }).then(res => {
        this.$message.success('保存成功!')
        this.dialogVisible = false
        this.getList()
      })
    },
    editItem (row) {
      this.current = JSON.parse(JSON.stringify(row))
      this.action = 1
      this.dialogVisible = true
      this.form = {
        thumb: this.current.thumb,
        title: this.current.title,
        title_en: this.current.title_en,
        start_at: this.current.start_at,
        end_at: this.current.end_at,
        page: this.current.page,
        page_en: this.current.page_en || {
          style: {
            padding: 0
          },
          modules: []
        }
      }
      
      this.pageLang = 'cn'
      this.initEditBox()
    },
    deleteItem (row) {
      this.$confirm('是否确认删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        request({
          url: '/filmfest/' + row.uuid,
          method: 'delete'
        }).then(res => {
          this.$message.success('删除成功!')
          this.getList()
        })
      }).catch()
    },
    format (str) {
      if (str) {
        return str.split(' ')[0]
      }
    },
    change (e, row) {
      request({
        url: '/filmfest/' + row.uuid,
        method: 'patch',
        data: {
          type: e ? 'hide' : 'show'
        }
      }).then(() => {}).catch(() => {
        this.getList()
      })
    },
    createFilmFest () {
      request({
        url: 'filmfest',
        method: 'post',
        data: this.form
      }).then(res => {
        this.$message.success('创建成功!')
        this.initEditBox()
        this.dialogVisible = false
        this.getList()
      })
    },
    handleSizeChange (e) {
      this.per_page = e
      this.handleCurrentChange(1)
    },
    handleCurrentChange (e) {
      this.page = e
      this.getList()
    },
    create () {
      this.action = 0
      this.dialogVisible = true
      this.form = {
        thumb: '',
        title: '',
        title_en: '',
        start_at: '',
        end_at: '',
        page: {
          style: {
            padding: 0
          },
          modules: []
        },
        page_en: {
          style: {
            padding: 0
          },
          modules: []
        }
      }
      this.initEditBox()
    },
    getList () {
      request({
        url: '/filmfest',
        params: {
          per_page: this.per_page,
          page: this.page,
          key: this.key
        }
      }).then(res => {
        this.list = res.data.list
        this.total = res.data.item_total
      })
    },
    selectThumb (key) {
      let list = []
      if (this.form[key]) {
        list = [this.form[key]]
      }
      this.$refs.upload.show(list, 'other', 1).then(res => {
        if (res.length) {
          this.form[key] = res[0]
        }
      }).catch()
    }
  }
}
</script>
<style lang="less" scoped>
/deep/ .el-form-item {
  margin-bottom: 20px!important;
}
.table {
  border: 1px solid #ebeef5;
  border-bottom: none;
  margin-top: 10px;
}
.pager {
  margin: 15px 0;
}
.addimg {
  width: 50px;
  height: 50px;
  text-align: center;
  line-height: 50px;
  color: #666;
  font-size: 17px;
  border: 1px dashed #999999;
  cursor: pointer;
}
.thumb {
  height: 50px;
  width: auto;
}
</style>



// WEBPACK FOOTER //
// src/views/movie/filmfest.vue